import types from './types'
export default {
  [types.SET_LOADING](state, isLoading) {
    if (isLoading == true) {
      state.totalRequest += 1;
    } else {
      state.totalRequest -= 1;
    }
    state.loading = state.totalRequest > 0;
  },
  setIsNavOpen(state, value) {
    state.isNavOpen = value
  },
  toggleNav(state) {
    state.isNavOpen = !state.isNavOpen
  },
  setIsMobileDensity(state, value) {
    state.isMobileDensity = value
  },
  [types.SET_TOGGLE_NAV](state) {
    state.isNavOpen = !state.isNavOpen
  },
}
